/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Grid } from '@material-ui/core';
import Widget from 'components/pages/Content/Widget';
import { WidgetsType } from 'components/pages/Content/types';

const WidgetsDoubleContainer = ({
  left,
  right,
}: {
  left: WidgetsType;
  right: WidgetsType;
}): JSX.Element => (
  <Grid container justify="center" spacing={3}>
    <Grid item xs={12} md={6}>
      <Grid container justify="flex-end">
        <Grid item xs={11}>
          <Widget widget={left} half />
        </Grid>
      </Grid>
    </Grid>
    <Grid item xs={12} md={6}>
      <Grid container>
        <Grid item xs={11}>
          <Widget widget={right} half />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export default WidgetsDoubleContainer;
